export default function highchartsVersion(localHighcharts = null) {
  const parts = (localHighcharts || Highcharts).version.split(' ');
  for (let i = 0; i < parts.length; i++) {
    var n = parseFloat(parts[i]);
    if (!isNaN(n)) {
      return n;
    }
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/chart/data/highchartsVersion.js